import { handleActions } from 'redux-actions';
import http from '../shared/http';
import intl from '../shared/intl';
import endpoints from '../../config/endpoints';

const DATA_FETCH_SUCCESS = 'user_api/data-fetch-success';
const DATA_FETCH_ERROR  = 'user_api/data-fetch-error';

// initialState state
const initialState = {
	data: null,
	error: false
};

// actions
export const actions = {
	fetchData: () => dispatch => {
		const request = http({
			url: [`${endpoints.PROFILE.MANAGER}`],
			method:'get',
			actions:[
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});
		request(dispatch);
	}
};

// reducers
const reducers = Object.assign({
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const [ manager ] = action.payload.map(res => res.data);
		return { ...state, data: { manager }};
	},
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	}
});

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	getData: state => state.userApi.data,
	getUserData: state => state.app.userData,
	getManager: state => state.userApi.data && state.userApi.data.manager,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/master-account/index.js